import { Paragraph, styled, View } from "@medbillai/ui";
import type { FeedbackOption } from "../types";
type OptionItemProps = {
  option: FeedbackOption;
  selected?: boolean;
  onPress: (option: FeedbackOption) => void;
};
const ItemContainer = styled(View, {
  borderRadius: "$4",
  backgroundColor: "$gray3",
  paddingHorizontal: "$4",
  paddingVertical: "$1",
  minHeight: "$7",
  alignItems: "center",
  justifyContent: "center",
  animation: "bouncyTight",
  variants: {
    selected: {
      true: {
        backgroundColor: "$gray12"
      }
    }
  } as const
});
const ItemText = styled(Paragraph, {
  textAlign: "center",
  animation: "bouncyTight",
  variants: {
    selected: {
      true: {
        color: "white"
      }
    }
  } as const
});
export default function OptionItem({
  option,
  selected,
  onPress
}: OptionItemProps) {
  return <ItemContainer selected={selected} onPress={() => onPress(option)} pressStyle={{
    scale: 0.95
  }} data-sentry-element="ItemContainer" data-sentry-component="OptionItem" data-sentry-source-file="OptionItem.tsx">
      <ItemText selected={selected} data-sentry-element="ItemText" data-sentry-source-file="OptionItem.tsx">{option.value}</ItemText>
    </ItemContainer>;
}